import {Component} from '@angular/core';

@Component({
    template: '<app-header-consulta></app-header-consulta>' +
    '<router-outlet></router-outlet>' +
    '<app-footer-consulta></app-footer-consulta>'
})
export class ConsultaLayoutComponent {
}
